import { CommentsThemeType, OCommentsThemeType } from "#/services/db";

const COMMENT_THEMES: Record<CommentsThemeType, string[]> = {
  [OCommentsThemeType.Rainbow]: [
    "#FF2A33",
    "#F98C1D",
    "#DAB84D",
    "#459E6F",
    "#3088C1",
    "#4B0082",
    "#8B00FF",
    "#FF00FF",
    "#FF1493",
    "#00FFFF",
  ],
  [OCommentsThemeType.UnoReverse]: [
    "#00FFFF",
    "#FF1493",
    "#FF00FF",
    "#8B00FF",
    "#4B0082",
    "#3088C1",
    "#459E6F",
    "#DAB84D",
    "#F98C1D",
    "#FF2A33",
  ],
  [OCommentsThemeType.Pastel]: [
    "#FFCCCC",
    "#FFB27F",
    "#FFE1CA",
    "#B3FFB3",
    "#CCCCFF",
    "#D9B3E6",
    "#E6Cfff",
    "#FFCCFF",
    "#FFC2DB",
    "#B3FFFF",
  ],
  [OCommentsThemeType.Mauve]: [
    "#E0B0FF",
    "#D473D4",
    "#C71585",
    "#9370DB",
    "#8B008B",
    "#9932CC",
    "#8A2BE2",
    "#800080",
    "#7B68EE",
    "#6A5ACD",
  ],
  [OCommentsThemeType.Electric]: [
    "#33FFFF",
    "#5FD5CC",
    "#7FCFA8",
    "#B78FD5",
    "#D180FF",
    "#FF66FF",
    "#FF99FF",
    "#6699FF",
    "#66CCFF",
    "#33CCFF",
  ],
  [OCommentsThemeType.Citrus]: [
    "#00FF00",
    "#32CD32",
    "#ADFF2F",
    "#FFFF00",
    "#FF8C00",
    "#FF4500",
    "#FF6347",
    "#FFA500",
    "#FFD700",
    "#7FFF00",
  ],
  [OCommentsThemeType.Blush]: [
    "#FF1493",
    "#FF69B4",
    "#FFB6C1",
    "#FF6347",
    "#FF4500",
    "#FFD700",
    "#FFA500",
    "#FF8C00",
    "#FF0000",
    "#DC143C",
  ],
} as const;

export default COMMENT_THEMES;
